import React from "react";
import { NavLink } from "react-router-dom";
import { routePaths } from "../constants/routes";
import "../style/studynotes.css";

const notes = [
  {
    id: "premium-store",
    title: "Premium PDFs / eBooks Store",
    description: "Paid QA PDFs and eBooks for JIRA, API Testing, Manual Testing, Selenium, SQL, and interview prep.",
    functionText: "Use this as the monetization hub for low-ticket digital products and premium study packs.",
    to: routePaths.premiumNotes,
    actionLabel: "Browse Premium Store",
    badge: "New",
  },
  {
    id: "manual-notes",
    title: "Manual Testing Basics",
    description: "Introduction to software testing concepts.",
    functionText: "Use for SDLC, STLC, test cases, defects, and QA fundamentals.",
    to: routePaths.manualTesting,
    actionLabel: "Read Notes",
  },
  {
    id: "automation-notes",
    title: "Automation Testing",
    description: "Learn automation strategy, tools, and frameworks.",
    functionText: "Use for Selenium, Playwright, reusable scripts, and regression suites.",
    to: routePaths.automationTestingTopic,
    actionLabel: "Read Notes",
  },
  {
    id: "api-notes",
    title: "API Testing",
    description: "Understand REST APIs and testing tools.",
    functionText: "Use for methods, status codes, payloads, auth, and Postman checks.",
    to: routePaths.apiTesting,
    actionLabel: "Read Notes",
  },
  {
    id: "performance-notes",
    title: "Performance Testing",
    description: "Learn load, stress, spike, and scalability testing.",
    functionText: "Use for response time, throughput, bottlenecks, and user load analysis.",
    to: routePaths.performanceTesting,
    actionLabel: "Read Notes",
  },
  {
    id: "regression-notes",
    title: "Regression Testing",
    description: "Retest existing features after code changes.",
    functionText: "Use for release checks, impact analysis, and automation candidate selection.",
    to: "/regression-testing",
    actionLabel: "Read Notes",
  },
  {
    id: "smoke-notes",
    title: "Smoke Testing",
    description: "Quickly verify that the main build features work.",
    functionText: "Use before deeper testing to decide whether a build is testable.",
    to: "/what-is-smoke-testing",
    actionLabel: "Read Notes",
  },
  {
    id: "sanity-notes",
    title: "Sanity Testing",
    description: "Check focused fixes or small feature changes.",
    functionText: "Use after bug fixes to confirm targeted behavior without full regression.",
    to: "/what-is-sanity",
    actionLabel: "Read Notes",
  },
  {
    id: "unit-notes",
    title: "Unit Testing",
    description: "Validate small code units in isolation.",
    functionText: "Use for functions, components, services, and early defect detection.",
    to: "/unit-testing",
    actionLabel: "Read Notes",
  },
  {
    id: "integration-notes",
    title: "Integration Testing",
    description: "Verify data flow between modules and systems.",
    functionText: "Use for API, database, UI-service, and third-party connection checks.",
    to: "/integration-testing",
    actionLabel: "Read Notes",
  },
  {
    id: "test-plan-notes",
    title: "Test Plan Template",
    description: "Plan scope, resources, timelines, and testing approach.",
    functionText: "Use for QA planning, entry/exit criteria, risks, and deliverables.",
    to: routePaths.testPlanTemplate,
    actionLabel: "Read Notes",
  },
  {
    id: "testing-tools-notes",
    title: "Testing Tools",
    description: "Compare useful QA tools for different testing needs.",
    functionText: "Use for selecting tools for UI, API, performance, security, and CI testing.",
    to: routePaths.testingTools,
    actionLabel: "Read Notes",
  },
  {
    id: "interview-notes",
    title: "Interview Questions",
    description: "Prepare topic-wise QA interview answers.",
    functionText: "Use for fresher, experienced, manual, automation, API, and HR rounds.",
    to: routePaths.interviewQuestions,
    actionLabel: "Read Notes",
  },
  {
    id: "jira-notes",
    title: "JIRA QA Notes Pack",
    description: "Premium JIRA notes with roadmap, JQL, workflows, reports, bug lifecycle, and interview answers.",
    functionText: "Paid pack in PDF-style format for QA learners who want structured JIRA notes, examples, and revision support.",
    to: routePaths.jiraNotes,
    actionLabel: "View Rs. 99 Pack",
    badge: "Premium",
    price: "Rs. 99",
  },
];

function StudyNotes() {
  return (
    <div className="study-container">
      <h1>Study Notes</h1>
      <p>Free notes plus premium study packs, paid PDFs, and eBooks for Software Testing, Automation, and QA interview preparation.</p>

      <div className="notes-list">
        {notes.map((note) => (
          <article id={note.id} className={`note-card ${note.badge ? "note-card-premium" : ""}`.trim()} key={note.id}>
            {note.badge && (
              <div className="note-card-topline">
                <span className="note-badge">{note.badge}</span>
                <span className="note-price">{note.price}</span>
              </div>
            )}
            <h3>{note.title}</h3>
            <p>{note.description}</p>
            <span className="note-function">{note.functionText}</span>
            <NavLink to={note.to}>{note.actionLabel || "Read Notes"}</NavLink>
          </article>
        ))}
      </div>
    </div>
  );
}

export default StudyNotes;
